/*eslint-disable*/
import React, { useState, useEffect } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Icon from "@material-ui/core/Icon";
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
// core components
import AdminNavbarLinks from "../Navbars/AdminNavbarLinks.js";

import styles from "../../assets/jss/material-dashboard-react/components/sidebarStyle.js";

const useStyles = makeStyles(styles);

export default function Sidebar(props) {
  const classes = useStyles();

  const [expandStates, setExpandStates] = useState({})
  // verifies if routeName is the one active (in browser input)
  function activeRoute(routeName) {
    return window.location.href.indexOf(routeName) > -1 ? true : false;
  }
  const { color, logo, image, logoText, routes } = props;

  useEffect(() => {
    setExpandStates(routes.map(route => activeRoute(route.path)));
  }, []);

  const handleClick = (index) => {
    const currentState = [...expandStates];
    currentState[index] = !currentState[index]
    setExpandStates(currentState);
  }

  var links = (
    <List className={classes.list}>
      {routes.map((prop, key) => {
        var activePro = " ";
        var listItemClasses;
        const isActiveRoute = activeRoute(prop.path);
        listItemClasses = classNames({
          [" " + classes[color]]: isActiveRoute
        });
        const whiteFontClasses = classNames({
          [" " + classes.whiteFont]: isActiveRoute
        });
        if (prop.display) {
          return (
            <React.Fragment key={key}>
              {prop.childrens ? (
                <>
                  <ListItem
                    button
                    className={classes.itemLink + listItemClasses}
                    onClick={() => handleClick(key)}
                  >
                    <ListItemIcon className={classes.itemIconWrapper}>
                      <prop.icon
                        className={classNames(classes.itemIcon, whiteFontClasses)}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={prop.name}
                      className={classNames(classes.itemText, whiteFontClasses)}
                      disableTypography={true}
                    />
                    {expandStates[key] ?
                      <ExpandLess className={classNames(classes.expandIcon, whiteFontClasses)} /> :
                      <ExpandMore className={classNames(classes.expandIcon, whiteFontClasses)} />
                    }
                  </ListItem>
                  <Collapse in={expandStates[key]} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding className={classes.nestedList}>
                      {prop.childrens.map((nestedChild, nestedKey) => {
                        activePro = " ";
                        listItemClasses;
                        const isActiveRoute = activeRoute(`${prop.path}${nestedChild.path}`);
                        listItemClasses = classNames({
                          [" " + classes[color]]: isActiveRoute
                        });
                        const whiteFontClasses = classNames({
                          [" " + classes.whiteFont]: isActiveRoute
                        });
                        return (
                          <NavLink
                            to={`${prop.path}${nestedChild.path}`}
                            className={activePro + classes.item + " " + classes.nested}
                            key={`nested-${nestedKey}`}
                          >
                            <ListItem button className={classes.nestedItemLink + listItemClasses}>
                              <ListItemIcon className={classes.nestedIconWrapper}>
                                <nestedChild.icon
                                  className={classNames(classes.nestedIcon, whiteFontClasses)}
                                />
                              </ListItemIcon>
                              <ListItemText
                                primary={nestedChild.name}
                                className={classNames(classes.itemText, whiteFontClasses)}
                                disableTypography={true}
                              />
                            </ListItem>
                          </NavLink>
                        );
                      })}
                    </List>
                  </Collapse>
                </>
              ) : (
                <NavLink
                  to={prop.path}
                  className={activePro + classes.item}
                  activeClassName="active"
                >
                  <ListItem button className={classes.itemLink + listItemClasses}>
                    <ListItemIcon className={classes.itemIconWrapper}>
                      <prop.icon
                        className={classNames(classes.itemIcon, whiteFontClasses)}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={prop.name}
                      className={classNames(classes.itemText, whiteFontClasses)}
                      disableTypography={true}
                    />
                  </ListItem>
                </NavLink>
              )}
            </React.Fragment>
          );
        }
      })}
    </List>
  );
  var brand = (
    <div className={classes.logo}>
      <a
        href="#"
        className={classes.logoLink}
      >
        <Typography variant="h5" className={classes.logoText}>
          {logoText}
        </Typography>
        <Typography variant="caption" className={classes.logoSubtext}>
          Admin Portal
        </Typography>
      </a>
    </div>
  );
  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor="right"
          open={props.open}
          classes={{
            paper: classes.drawerPaper
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true // Better open performance on mobile.
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>
            <AdminNavbarLinks />
            {links}
          </div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : null}
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer
          anchor={props.rtlActive ? "right" : "left"}
          variant="permanent"
          open
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive
            })
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>{links}</div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : null}
        </Drawer>
      </Hidden>
    </div>
  );
}

Sidebar.propTypes = {
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
  logo: PropTypes.string,
  image: PropTypes.string,
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool
};
